import { applyMiddleware, compose, createStore as reduxCreateStore, Reducer, Store } from 'redux';
import { default as ReduxThunk } from 'redux-thunk';

import { ImmutableTypes, ReducerFunction } from './redux';

export function createStore<T extends ImmutableTypes>(reducer: ReducerFunction<T>, name: string): Store<T> {
  const middlewares = [ReduxThunk];

  let composeEnhancers = compose;
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name });
  }
  return reduxCreateStore(reducer as Reducer<T>, composeEnhancers(applyMiddleware(...middlewares))) as Store<T>;
}
